import { Stack } from '@mui/material';
import React from 'react';
import { Advantages } from 'website/components/Advantages';
import { CompanyValues } from 'website/components/CompanyValues';
import { JobAdsSection } from 'website/components/JobAdsSection';
import { ContentLayout } from 'website/components/Layout/components/ContentLayout';
import { Offerings } from 'website/components/Offerings';
import { RecentBlogPosts } from 'website/components/RecentBlogPosts';
import { Subscribe } from 'website/components/SubscribeSection';
import { LoginSection } from 'website/components/LoginSection';
import { TopSection } from 'website/components/TopSection';
import BackgroundImage from '../assets/background.png';

export const Homepage = () => {

  return (
    <ContentLayout>
      <TopSection />
      <LoginSection />
      <JobAdsSection />
      {/* <Offerings /> */}
      <CompanyValues />
      {/* <Advantages /> */}
      <RecentBlogPosts />
      <Stack
        sx={{
          backgroundImage: `url(${BackgroundImage})`,
          backgroundColor: 'grey.300',
          backgroundPosition: 'center',
          backgroundSize: "cover",
          backgroundRepeat: 'no-repeat',
          position: "relative",
          // The parent Stack centers children that are wider than it
          // (align-items: center), which throws off the left:50% /
          // margin-left:-50vw full-bleed trick on mobile. Stretching
          // this box to the parent's start edge keeps that math correct.
          alignSelf: "flex-start",
          ml: "-50vw",
          left: "50%",
          width: "100vw",
        }}
      >
        <Stack
          width={1}
          maxWidth={{xs:664, md: 1200}}
          mx="auto"
          boxSizing="border-box"
          px={{xs: 4, md: 6}}
          sx={{
            // Subscribe's own top/bottom padding is uneven (30px/50px);
            // shift it down by half the difference so it's visually
            // centered in the picture without changing the total height.
            mt: 1.25,
            mb: -1.25,
          }}
        >
          <Subscribe />
        </Stack>
      </Stack>
    </ContentLayout>
  );
};
